module.exports = __webpack_public_path__ + "static/img/405.c82f2dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout/error-page/405.png
// module id = EC8k
// module chunks = 7